import HBEmpty from "@/components/HBEmpty";
import React from "react";

export default function SearchEmpty(props) {
  const { title = "没有找到你要的内容", subtitle = "你可以换一个词重新搜索" } =
    props;
  return (
    <HBEmpty
      image="//cdn.dancf.com/fe-assets/img/741b761023880576e19b25c721cc400d.png"
      title={title}
      subtitle={subtitle}
    />
  );
}
